import { useRoleAuth, useTransfersDrawer } from '@src/hooks';
import {
  ACTION,
  BLOTTER_TABLE_FILTERS_CONTAINER_ID,
  Box,
  Button,
  ButtonVariants,
  FormControlSizes,
  HStack,
  IconName,
  MixpanelEventSource,
  usePortal,
} from '@talos/kyoko';

export function TransfersFilterRow({ showNewTransfer }: { showNewTransfer: boolean }) {
  const { openTransfersDrawer } = useTransfersDrawer();
  const { isAuthorized } = useRoleAuth();
  const canSubmitTransfer = isAuthorized(ACTION.SUBMIT_TRANSFER);
  const { setPortalRef: filtersContainerRef } = usePortal(BLOTTER_TABLE_FILTERS_CONTAINER_ID);
  return (
    <HStack gap="spacing4">
      {canSubmitTransfer && showNewTransfer && (
        <Button
          startIcon={IconName.Plus}
          variant={ButtonVariants.Default}
          size={FormControlSizes.Small}
          onClick={() => openTransfersDrawer({ source: MixpanelEventSource.TransferBlotter })}
        >
          New Transfer
        </Button>
      )}
      <Box ref={filtersContainerRef} />
    </HStack>
  );
}
